import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { ConstantConfig } from 'src/app/core/config/constant.config';
import { AuthService } from 'src/app/core/services/auth-service';
import { ClientDetailService } from 'src/app/core/services/client-detail-service';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-error-not-found',
  templateUrl: './error-not-found.component.html',
  styleUrls: ['./error-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ErrorNotFoundComponent implements OnInit, OnDestroy {
  currentYear: string = moment().format('YYYY');
  sectionTitle: string = '';
  eventSubscription: Array<Subscription> = [];
  showFullPage: boolean = true;
  private resizeObserver!: ResizeObserver;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private clientDetailService: ClientDetailService,
    private authService: AuthService,
  ) {
    this.sectionTitle = this.route.snapshot.data?.title || '';
    this.showFullPage = this.route.snapshot.queryParams?.fp == 'F' ? true : false;
  }

  ngOnInit(): void {
    document.body.classList.add('error-page-active');
      if (!this.showFullPage) {
        this.observeHeader();
      }
  }

private observeHeader(): void {
  const tryObserve = () => {
    const stickyBar = document.querySelector('.page-sticky-bar') as HTMLElement;
    const headerBlock = document.querySelector('.header-block') as HTMLElement;

    if (!headerBlock) {
      setTimeout(tryObserve, 100);
      return;
    }

   const update = () => {
  const stickyHeight = stickyBar ? stickyBar.getBoundingClientRect().height : 0;
  const headerHeight = headerBlock.getBoundingClientRect().height;
  const footerHeight = document.querySelector('.page-footer')?.getBoundingClientRect().height ?? 0;
  
  // ✅ Math.floor to avoid sub-pixel rounding gaps
  const total = Math.floor(stickyHeight + headerHeight + footerHeight);
  document.documentElement.style.setProperty('--total-header-height', `${total}px`);
};

    update();

    // ✅ watch element size changes
    this.resizeObserver = new ResizeObserver(update);
    this.resizeObserver.observe(headerBlock);
    if (stickyBar) this.resizeObserver.observe(stickyBar);

    // ✅ also watch window resize for zoom in/out
    window.addEventListener('resize', update);
    this.resizeListener = update;
  };

  setTimeout(tryObserve, 0);
}

private resizeListener!: () => void;

ngOnDestroy(): void {
  document.body.classList.remove('error-page-active');
  this.resizeObserver?.disconnect();
  window.removeEventListener('resize', this.resizeListener);
  document.documentElement.style.removeProperty('--total-header-height');
}

  goBack(): void {
    // const slug = this.clientDetailService.CLIENT_ID;
    // if(slug){
    //   const isAuthenticated = this.authService.isAuthenticated();
    //   const url = !isAuthenticated ? `/${slug}` : `/${slug}`;
    //   this.router.navigate([url]);
    // }else{
    //   window.location.href = '/';
    // }
    if (sessionStorage[ConstantConfig.CLIENT_SLUG]) {
      window.history.go(-1);
    } else {
      window.location.href = environment.LOGIN_URL;
    }
  }

}